// hooks
import { getUsersImagePath } from '@/common/getImagePath';
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import type { MAvatarProps } from './@material-extend/MAvatar';
import createAvatar from '../common/createAvatar';

export default function MyAvatar({ ...other }: MAvatarProps) {
  const { user } = useAuth();

  return (
    <MAvatar
      src={getUsersImagePath(user?.photoUrl)}
      alt={user?.displayName}
      color={user?.photoUrl ? 'default' : createAvatar(user?.displayName).color}
      {...other}
    >
      {createAvatar(user?.displayName).name}
    </MAvatar>
  );
}
